import React, { createContext, useState, useEffect } from "react";
import { getUserInfo, logout } from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthLoading, setIsAuthLoading] = useState(true);

    const fetchUser = async () => {
        const hasTokenFallback = Boolean(localStorage.getItem("access_token"));
        const isPlainHttp = window.location.protocol === "http:";
        if (!hasTokenFallback && isPlainHttp) {
            setUser(null);
            setIsAuthLoading(false);
            return;
        }

        try {
            const response = await getUserInfo();
            setUser({
                username: response.data.username,
                role: response.data.role,
                accountStatus: response.data.account_status,
                isVerified: response.data.is_verified,
                isSuperadmin: response.data.is_superadmin,
            });
        } catch (err) {
            if (err.response?.status !== 401) {
                console.error("Failed to fetch user", err);
            }
            if (err.response?.status === 401) {
                localStorage.removeItem("access_token");
            }
            setUser(null);
        } finally {
            setIsAuthLoading(false);
        }
    };

    const handleLogout = async () => {
        try {
            await logout();
        } catch (err) {
            // The server already cleared the auth cookie via Set-Cookie on its redirect
            // response before the redirect target itself 404s — ignore and clear locally.
        } finally {
            localStorage.removeItem("access_token");
            setUser(null);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, isAuthLoading, handleLogout }}>
            {children}
        </AuthContext.Provider>
    );
};
